import { Grid, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { GridDirection } from '@mui/material/Grid'
import * as React from 'react'

const StyledPaper = styled(Paper)(({ theme }) => ({
  margin: 4,
  padding: theme.spacing(2),
  paddingTop: 10,
  border:
    theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.12)' : undefined,
}))

interface ICardWithNoTitleProps {
  children?: React.ReactNode
  formGridDirection?: GridDirection
  formGridAlignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
  headerStyle?: React.CSSProperties
  fullHeight?: boolean
  onClick?: () => void
}

const CardWithNoTitle: React.FC<ICardWithNoTitleProps> = ({
  children,
  formGridAlignItems = 'center',
  formGridDirection = 'row',
  fullHeight,
}) => {
  return (
    <StyledPaper style={{ height: fullHeight ? '100%' : 'auto' }}>
      <Grid container direction="column" spacing={2}>
        <Grid
          container
          item
          direction={formGridDirection}
          xs={12}
          spacing={1}
          alignItems={formGridAlignItems}
          style={{ marginLeft: 0, paddingTop: '15px' }} // this is needed because material UI grid spacing applies -8px margin.
        >
          {children}
        </Grid>
      </Grid>
    </StyledPaper>
  )
}

export default CardWithNoTitle
